import { BREADCRUMB_NAME } from 'constants/common';

const Routers = {
  All: '/*',
  Dashboard: '/',
  Login: '/login',
  NotFound: '/not-found',
  // Job Management
  Jobs: '/job-management',
  CreateJob: '/job-management/create',
  DetailJob: '/job-management/detail',
  WorkflowManagement: '/workflow-management',
  // Article Management
  Articles: '/articles-management',
  CreateArticle: '/articles-management/create',
  DetailArticle: '/articles-management/detail',
  InfoArticle: '/articles-management/info',
  // Candidate Management
  Candidates: '/candidates-management',
  Overview: '/overview',
  Information: '/candidates-management/information',
  CreateMeeting: '/candidates-management/create',
  CreateMeeting2: '/candidates-management/create2',
  CandidateHistory: '/candidates-management/history',
  CandidateEssay:'/candidate/test',
  // User Management
  Users: '/user-management',
  // Training Management
  Training: '/training-management',
  TrainingView: '/training-management/view',
  TrainingEdit: '/training-management/edit',
  // Hashtag Management
  Hashtags: '/hashtag-management',
  // Marathon Event
  Marathon: '/marathon-event',
  // Test Management
  TestManagement: '/test-management',
  CreateTest: '/test-management/create',
  EditTest: '/test-management/edit',
  DetailTest: '/test-management/detail',
  DetailCadidateTest: '/test-management/detail-candidate-test',
  // BOD Management
  BODInterviewManagement: '/bod-interview-management',
  // InterviewList: '/bod-interview-management/interview-list',
  DetailEvaluate: '/bod-interview-management/detail',
  // Component Test
  ComponentTest: '/component-test'
};

export const RoutersBreadCrumb = [
  { path: Routers.Dashboard, breadcrumbName: 'Dashboard' },
  { path: Routers.Login, breadcrumbName: 'Login' },
  { path: Routers.NotFound, breadcrumbName: 'NotFound' },
  { path: Routers.Jobs, breadcrumbName: 'menu.label.jobsManagement' },
  { path: `${Routers.DetailJob}/:id`, breadcrumbName: 'page.jobs.titleDetail' },
  { path: Routers.CreateJob, breadcrumbName: 'page.jobs.titleCreate' },
  { path: Routers.Articles, breadcrumbName: 'Articles Management' },
  { path: Routers.Overview, breadcrumbName: 'Overview.Candidates' },
  { path: Routers.Candidates, breadcrumbName: 'Candidates' },
  { path: `${Routers.Information}/:id`, breadcrumbName: 'Information' },
  { path: `${Routers.CreateMeeting}/:id`, breadcrumbName: 'Create' },
  {
    path: Routers.CreateMeeting,
    breadcrumbName: localStorage.getItem(BREADCRUMB_NAME) ? String(localStorage.getItem(BREADCRUMB_NAME)) : ''
  },
  { path: `${Routers.DetailArticle}/:id`, breadcrumbName: 'Detail' },
  { path: Routers.CreateArticle, breadcrumbName: 'Create' },
  { path: `${Routers.InfoArticle}/:id`, breadcrumbName: 'Info' },
  { path: Routers.WorkflowManagement, breadcrumbName: 'common.label.view' },
  // User BreadCrumb
  { path: Routers.Users, breadcrumbName: 'User Management' },
  // Training BreadCrumb
  { path: Routers.Training, breadcrumbName: 'Training Management' },
  { path: Routers.TrainingView, breadcrumbName: 'View' },
  { path: Routers.TrainingEdit, breadcrumbName: 'Edit' },
  { path: Routers.Hashtags, breadcrumbName: 'Hashtag Management' },
  { path: Routers.Marathon, breadcrumbName: 'Marathon Event' },
  //Leader BreadCrumb
  { path: Routers.TestManagement, breadcrumbName: 'Test list' },
  { path: Routers.CreateTest, breadcrumbName: 'Create' },
  { path: `${Routers.DetailTest}/:id`, breadcrumbName: 'Detail test' },
  { path: `${Routers.DetailCadidateTest}/:id`, breadcrumbName: 'Detail test' },
  { path: `${Routers.EditTest}/:id`, breadcrumbName: 'Edit test' },
  //BOD BreadCrumb
  { path: Routers.BODInterviewManagement, breadcrumbName: 'BOD interview management' },
  // { path: Routers.InterviewList, breadcrumbName: 'Interview list' },
  { path: `${Routers.DetailEvaluate}/:id`, breadcrumbName: 'Detail' }
];

export const PATH_UNUSED_BREADCRUMB = ['/job-management'];

export default Routers;
